// extracted by mini-css-extract-plugin
export default {"leftPadding":"AppointmentView_leftPadding__0l2dJ"};